import { Component, HostBinding } from '@angular/core';
import {NzSpaceSize} from 'ng-zorro-antd/space/types';

@Component({
	selector: 'app-topbar',
	templateUrl: './topbar.component.html',
	styleUrls: ['./topbar.component.scss'],
})
export class TopbarComponent {
	
	@HostBinding('class.print-hide')
	public readonly printHide = true;
	
	size: NzSpaceSize = 'middle';
}
